<div class="dropdown-main ym-display-flex ym-flex-direction-column ym-p-5 ym-gap-5">
    <form action="javascript:void(0)" method="post" (submit)="submitPhones()">
        <div class="ym-display-flex ym-flex-direction-column ym-gap-3">
            <div class="label-container ym-display-flex ym-align-items-center ym-gap-3">
                <div class="ym-text-color ym-display-flex ym-align-items-center ym-gap-2 ym-w-full">
                    <span class="text ym-font-base ym-line-height-normal">{{label}}</span>
                    <span class="optional-indicator ym-text-secondary ym-display-inline-block" *ngIf="!required && !hideOptional">
                        <!-- <span class="icon ym-svg-sm ym-mt-n2">
                            <ym-icon [iconName]="iconNames.REQUIRED"></ym-icon>
                        </span> -->
                        (optional)
                    </span>
                    <span class="inline-info ym-svg-base" *ngIf="inlineInfo">
                        <ym-inline-info [hideTooltip]="true">
                            {{inlineInfo}}
                        </ym-inline-info>
                    </span>
                </div>
            </div>
            <ng-container *ngFor="let phone of displayPhoneValue; let i = index">
                <ng-container *ngTemplateOutlet="phoneEdit; context:{phone: phone, index: i}"></ng-container>
            </ng-container>
            <ym-button [icon]="iconNames.PLUS" [type]="buttonTypes.GHOST_LINK" [variant]="buttonVariants.ICON_AND_TEXT"
                class="ym-ml-n4" (onClick)="addPhone()">Add phone</ym-button>
        </div>

        <div class="actions ym-display-flex ym-gap-3 ym-justify-content-end">
            <ym-button [type]="buttonTypes.GHOST" (onClick)="closePopover()">Cancel</ym-button>
            <ym-button [type]="buttonTypes.PRIMARY" [typeAttribute]="'submit'">Save</ym-button>
        </div>
    </form>
</div>

<ng-template #phoneEdit let-phone="phone" let-i="index">
    <div class="content ym-display-flex ym-gap-3">
        <ym-input [name]="'phone'" [type]="'tel'" [showLabel]="false" [required]="i === 0? true: false"
            [value]="phone.value" [pattern]="'^[0-9\\+\\(\\)\\-\\/\\s]*$'" [error]="!phone.isUnique" [errorText]="'Same phone already exists'" (valueChange)="updateValue(i, $event, phone)"
            class="ym-w-full"></ym-input>
        <ym-dropdown [showDropdown]="phone.isDropdownOpen" (onDropdownClose)="toggleLabelDropdown(i, false)"
            (selectedOption)="updateLabel(i, $event)" [selectionType]="dropdownSelectionTypes.CHECKMARK"
            [position]="popoverPositions.BELOW_LEFT_START" [dropdownOption]="labelDropdownOptions">
            <ng-container trigger>
                <ym-button [fullWidth]="true" [variant]="buttonVariants.DROPDOWN"
                    (onClick)="toggleLabelDropdown(i, true)" class="ym-w-13">
                    {{phone.label}}
                </ym-button>
            </ng-container>
        </ym-dropdown>
        <ym-button [icon]="iconNames.DELETE" [type]="buttonTypes.GHOST" [variant]="buttonVariants.ICON_ONLY"
            [tooltip]="'Remove'" *ngIf="displayPhoneValue.length > 1" (onClick)="removePhone(i)">Remove</ym-button>
    </div>
</ng-template>